import React from "react";

const AppDownload = props => {
  return (
    <div className="greyTheme appDownload staticSection pb0">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5 col-6 offset-md-2">
            <h4>Download the app and never miss a beat.</h4>
            <p>
              Follow the topics and companies that matter to you. Receive alerts
              when they feature on ausbiz.
            </p>
            <a
              href="https://apps.apple.com/us/app/apple-store/id1494428911"
              target="_blank"
            >
              <img src="/assets/svg/app-store.svg" alt="Apple_App_Store" />
            </a>
          </div>
          <div className="col-md-3 col-6 imageSection">
            <a
              href="https://apps.apple.com/us/app/apple-store/id1494428911"
              target="_blank"
            >
              <img
                src="/assets/mobile.png"
                className="img-fluid"
                alt="ios_app"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownload;
